import React, { Fragment } from 'react'
import LandingLayout from 'components/LandingLayout/LandingLayout'
import Hero from './Hero/Hero'
import About from './About/About'
import Features from './Features/Features'
import HowItWorks from './HowItWorks/HowItWorks'
import Pricing from './Pricing/Pricing'
import FAQ from './FAQ/FAQ'
import Contact from './Contact/Contact'
import BackToTop from 'components/BackToTop/BackToTop'

const Landing: React.FC = () => {
  return (
    <Fragment>
      <LandingLayout>
        <main>
          <Hero />
          <About />
          <Features />
          <HowItWorks />
          <Pricing />
          <FAQ />
          <Contact />
        </main>
      </LandingLayout>
      <BackToTop />
    </Fragment>
  )
}

export default Landing
